import React from 'react';
import { useSettingsRedux } from '../hooks/useSettingsRedux';
import './CategorySelector.css';

export interface Department {
  id: number;
  title: string;
}

interface CategorySelectorProps {
  activeDepartmentId: number | null;
  onDepartmentChange: (departmentId: number) => void;
}

const CategorySelector: React.FC<CategorySelectorProps> = ({ activeDepartmentId, onDepartmentChange }) => {
  const { settings } = useSettingsRedux();

  // Don't render if no departments available
  if (!settings?.departments || settings.departments.length === 0) {
    return null;
  }

  return (
    <div className="category-selector">
      {settings.departments.map((department) => (
        <button
          key={department.id}
          className={`category-button ${activeDepartmentId === department.id ? 'active' : ''}`}
          onClick={() => onDepartmentChange(department.id)}
        >
          {department.title}
        </button>
      ))}
    </div>
  );
};

export default CategorySelector;
